(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('entityTranslationRow', ['ItemTableService', '$uibModal', EntityTranslationRowFn]);

    function EntityTranslationRowFn(ItemTableService, $uibModal) {
        var directive = {
            link: link,
            restrict: 'A',
            replace: true,
            templateUrl: '/app/global/templates/rf-global-entity-translation-row.template.html'
        };
        return directive;

        function link(scope, element, attrs) {

            // if editing -> this is the original backup
            var original = null;

            // deactivate item (remove from table if it is new)
            scope.deactivate = function (index) {
                ItemTableService.deactivate(scope.translation, index);
            };

            // edit item
            scope.edit = function () {
                original = ItemTableService.edit(scope.translation);
            };

            // short Text
            scope.shortText = function (value) {
                return ItemTableService.shortText(value);
            };

            // is there 
            scope.isValueAvailable = function (value) {
                return value !== undefined && value !== null;
            };

            // cancel editing -> show original
            scope.cancel = function (index) {
                if (original === null) {
                    ItemTableService.remove(index);
                }
                else {
                    // replace original with current edited item
                    ItemTableService.replace(original, index);
                    // remove backup
                    original = null;
                } // else
            };

            // save editing values
            scope.save = function () {
                ItemTableService.save(scope.translation);
            };

            // if editInSummernote is set, opens a modal with summernote for editing
            scope.fieldClicked = function (translation, key) {
                if (scope.editInSummernote === true) {
                    var summernoteContent = translation[key];
                    var modalInstance = null;

                    // open modal with summernote
                    modalInstance = $uibModal.open({
                        backdrop: 'static',
                        keyboard: false,
                        animation: true,
                        templateUrl: '/app/global/templates/rf-global-summernote-modal.template.html',
                        controller: 'SummernoteModalController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            title: function () {
                                return key;
                            },
                            content: function () {
                                return summernoteContent;
                            },
                            modalData: function () {
                                return {
                                    title: '',
                                    content: '',
                                    defaultContent: '',
                                    showResetButton: false
                                };
                            }
                        }
                    });

                    // update field content when modal is closed
                    modalInstance.result.then(function (editedContent) {
                        summernoteContent = editedContent;
                    });

                    // set value in array so it gets update in view, regardless which closing-method was used
                    modalInstance.result.finally(function () {
                        translation[key] = summernoteContent;
                    });
                }
            };
        }
    }

})();